import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { UserConfigurationPartialState } from '..';
import * as calendarConfigurationActions from './calendar-configuration.actions';
import { calendarConfigurationQuery } from './calendar-configuration.selectors';

@Injectable()
export class CalendarConfigurationFacade {
  constructor(private readonly store: Store<UserConfigurationPartialState>) {}

  /** form */
  calendarConfigurationForm$ = this.store.pipe(
    select(calendarConfigurationQuery.getCalendarConfigurationForm)
  );

  isFormUnchanged$ = this.store.pipe(
    select(calendarConfigurationQuery.getIsFormUnchanged)
  );

  /** dialog */
  confirmChanges() {
    this.store.next(calendarConfigurationActions.confirmChanges());
  }

  cancelChanges() {
    this.store.next(calendarConfigurationActions.cancelChanges());
  }

  openCalendarConfigurationDialog() {
    this.store.dispatch(calendarConfigurationActions.openCalendarConfigurationDialog());
  }
}
